var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHydrationSuccessIcon = function SvgHydrationSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a984f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f8842"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-hydration_success_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hydration_success_icon",
    clipPath: "url(#clip-hydration_success_icon)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(2 2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-1986-902v-17a3,3,0,0,1,3-3,3,3,0,0,1,3,3v11h23a3,3,0,0,1,3,3,3,3,0,0,1-3,3Z",
    transform: "translate(2072.267 -719.119) rotate(-45)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHydrationSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hydration_success_icon.ff5f95be.svg";
export { ForwardRef as ReactComponent };